var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1573 5.086L10.4498 5.793L10.0963 5.4395L7.97533 7.5605L7.62183 9.3285L6.91433 10.0355L4.79333 7.914L2.31833 10.389L1.61133 9.682L4.08633 7.207L1.96483 5.086L2.67183 4.3785L4.44033 4.025L6.56133 1.904L6.20783 1.5505L6.91483 0.843002L11.1573 5.086Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPin);
export default __webpack_public_path__ + "static/media/chatPin.2c0c7e93.svg";
export { ForwardRef as ReactComponent };